export default {
    data: () => ({
        contactActivities: [
            { id: 'denonciations', label: 'Dénonciations' },
            { id: 'options', label: 'Options' },
            { id: 'sales', label: 'Réservations' }
        ]
    })
};
